import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';

export enum ESearchRoute {
  search = 'search',
  estate = 'estate',
  tenant = 'tenant',
  owner = 'owner',
}

TaRoutes.addRoute({
  key: ESearchRoute.search,
  url: 'search',
  children: [
    { key: ESearchRoute.estate, url: 'estate' },
    { key: ESearchRoute.tenant, url: 'tenant' },
    { key: ESearchRoute.owner, url: 'owner' },
  ],
});

export const searchRoutes: Routes = [
  {
    path: '',
    title: 'app.pages.search.title',
    loadComponent: () => import('./pages/search/search').then((c) => c.SearchPage),
    children: [
      {
        path: '',
        redirectTo: TaRoutes.getAbsoluteUrl([ESearchRoute.search, ESearchRoute.estate]),
        pathMatch: 'full',
      },
      {
        path: TaRoutes.getUrl([ESearchRoute.search, ESearchRoute.estate]),
        title: 'app.pages.search_estates.title',
        loadComponent: () =>
          import('./pages/search-estate/search-estate').then((c) => c.SearchEstatePage),
      },
      {
        path: TaRoutes.getUrl([ESearchRoute.search, ESearchRoute.tenant]),
        title: 'app.pages.search_tenants.title',
        loadComponent: () =>
          import('./pages/search-tenant/search-tenant').then((c) => c.SearchTenantPage),
      },
      {
        path: TaRoutes.getUrl([ESearchRoute.search, ESearchRoute.owner]),
        title: 'app.pages.search_owners.title',
        loadComponent: () =>
          import('./pages/search-owner/search-owner').then((c) => c.SearchOwnerPage),
      },
    ],
  },
];
